export function menuDesktopInit() {
	console.log("deskcito navbar run");
  const events = () => {
    const headerNavBar = document.querySelector('.headerDesktop__navBar');
		const headerNavBarColumns = document.querySelectorAll('.headerDesktop__navBarColumn');
		const subMenuLinks = document.querySelectorAll('.subMenu__link');
		const subMenuBg = document.querySelectorAll('.subMenu__bgBox');
		const searchButton = document.querySelectorAll('.menuShopButtons__icon--search');
		const searchBar = document.querySelector('.headerDesktop__navBarColumn--search');

    const eventsOnScroll = () => {
      if(window.scrollY > 139) {
        (!headerNavBar.classList.contains('scrolled')) ? headerNavBar.classList.add('scrolled') : '' ;

        headerNavBarColumns.forEach(element => {
          (!element.classList.contains('scrolled')) ? element.classList.add('scrolled') : '' ;
        });
      } else {
        (headerNavBar.classList.contains('scrolled')) ? headerNavBar.classList.remove('scrolled') : '' ;

        headerNavBarColumns.forEach(element => {
          (element.classList.contains('scrolled')) ? element.classList.remove('scrolled') : '' ;
        });
      }
    };

		

		const resetSubMenuBg = async () => {
			await subMenuBg.forEach(element => {
				(element.classList.contains('active')) ? element.classList.remove('active') : '' ;
			});
		}

		const clickSearchButton = () => {
			(searchBar.classList.contains('active')) ? searchBar.classList.remove('active') : searchBar.classList.add('active');
		}

		//run events
		window.addEventListener('scroll', eventsOnScroll);
		
		subMenuLinks.forEach(link => {
			link.addEventListener('mouseenter', async ()=>{
				await resetSubMenuBg();
				const id = link.getAttribute('termData-id');

				await subMenuBg.forEach(element => {
					(element.getAttribute('bgData-id') == id) ? element.classList.add('active') : '' ;
				});
			})
		});

		// searchButton.addEventListener('click', clickSearchButton);

		searchButton.forEach(button => {
			button.addEventListener('click', clickSearchButton);
		
		});

  }
  events();
  
}